// extracted by mini-css-extract-plugin
export default {"item":"styles_item__eefvI","icon":"styles_icon__VEQQ9","content":"styles_content__krHam","inner":"styles_inner__o4NRc"};